import { useContext } from 'react';
import SessionContext from 'src/contexts/SessionContext';
import { GTMEvent, TaskState } from 'src/types';
import { useTaskById } from 'src/hooks';
import { sendGTMEvent } from 'src/utils';
import styles from './BlockedTaskMessage.module.scss';

interface BlockedTaskMessageProps {
  taskId?: string;
  taskState?: TaskState;
}

export const BlockedTaskMessage = ({
  taskId,
  taskState,
}: BlockedTaskMessageProps) => {
  const { setCurrentTaskId } = useTaskById();
  const { onToggleVisibleTaskViewModal } = useContext(SessionContext);

  if (taskState !== TaskState.BLOCKED || !taskId) {
    return null;
  }

  const handleClick = () => {
    setCurrentTaskId(taskId);
    onToggleVisibleTaskViewModal(true);
    sendGTMEvent(GTMEvent.TASK_VIEW_OPENING, {
      task_id: taskId,
      task_state: taskState,
    });
  };

  return (
    <div className={styles.root}>
      <span>We need you to confirm the detail.</span>
      <button onClick={handleClick} className={styles.openTaskButton}>
        Click here
      </button>
    </div>
  );
};
